import AltQuotePage from "./AltQuotePage";

export default AltQuotePage;
